// extracted by mini-css-extract-plugin
export default {"nfContainer":"Notfound_nfContainer__zRYQR"};